module.exports = __webpack_public_path__ + "media/images/computer_icon-bf3817776dccc3d74ebc4c7fcc8c785c.png";